export enum QuickLinkTypeEnum {
  FAVORITES = 'Favorites',
  HISTORY = 'History',
}
